import React, { memo, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style';

const PopUpImageCenter = (props) => {
  const { children, title, show, onHide, bgColor, modalSize = 'image', style, backdrop, keyboard, className, ...rest } = props;

  // no need this because we can simply add "centered" props to modal to vertically centered automatically
  // const modalContainerStyles = { ...styles.modalContainer };

  let styleModal = { }
  if (style) {
    styleModal = { ...styleModal, ...style }
  }
  if (typeof title !== 'undefined' && title === '') {
    styleModal.boxShadow = 'none';
  }
  if (bgColor) {
    styleModal.backgroundColor = 'transparent';
  }
  let dialogClassNameModal = 'modal-dialog-'+modalSize+'-size'
  
  return (
    <Modal className={className} centered {...rest} show={show} dialogClassName={dialogClassNameModal} onHide={onHide} style={styleModal} backdrop={backdrop} keyboard={keyboard}>
      {title ? (
        <Fragment>
          <Modal.Header
            className="p-24"
            closeButton
            style={styles.modalCenterHeader}
          >
            <Modal.Title as='div'>
              <span style={{ color: 'transparent' }}>{title}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ backgroundColor: bgColor }} className="p-24">{children}</Modal.Body>
        </Fragment>
      ) : (
        <Modal.Body style={{ backgroundColor: bgColor }} className="p-24">{children}</Modal.Body>
      )}
    </Modal>
  );
};

export default memo(PopUpImageCenter);
